import { usePublicPagesAvailability } from '@/hooks/use-public-pages-availability';
import { PublicSite } from './public-site';
import { PublicPagesLoading, PublicSignInScreen } from './public-sign-in-screen';

/** Signed-out fallback for protected application links; follows the public visitor pages switch. */
export function WelcomeLanding() {
  const availability = usePublicPagesAvailability(true);
  if (availability === 'loading') return <PublicPagesLoading />;
  return availability === 'on' ? <PublicSite page="welcome" /> : <PublicSignInScreen />;
}
